import React from 'react'

import { Checkbox as LegalDisclaimer } from '../../Checkbox'

const Checkbox = ({ ...rest }) => (
  <LegalDisclaimer className="form-checkbox" {...rest} />
)

export default Checkbox
